import { createContext } from 'react';

export type Branding = {
  companyName: string;
  companyAddress: string;
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  legalCompany: string;
  legalAddress: string;
  legalEmail: string;
  imprintUrl: string;
  privacyUrl: string;
  termsUrl: string;
  legalText: string;
};

export type BrandingContextType = {
  branding: Branding;
  setBranding: (b: Branding) => void;
  refresh: () => Promise<void>;
};

export const BrandingContext = createContext<BrandingContextType | undefined>(undefined);
